var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 60,
    viewBox: "0 0 58 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.894531 4.2607C0.894531 1.91096 2.78025 0 5.11387 0H44.7308C47.0645 0 48.9502 1.91097 48.9502 4.2607V19.129C48.9502 19.9026 48.328 20.5298 47.5606 20.5298C46.7932 20.5298 46.1711 19.9026 46.1711 19.129V4.2607C46.1711 3.45145 45.5229 2.80156 44.7308 2.80156H5.11387C4.32181 2.80156 3.67365 3.45146 3.67365 4.2607V55.7393C3.67365 56.5486 4.32179 57.1984 5.11387 57.1984H19.2628C20.0302 57.1984 20.6523 57.8256 20.6523 58.5992C20.6523 59.3728 20.0302 60 19.2628 60H5.11387C2.78026 60 0.894531 58.0891 0.894531 55.7393V4.2607Z",
    fill: "#664BF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.127 13.4242C12.127 12.6506 12.7491 12.0234 13.5165 12.0234H35.5179C36.2853 12.0234 36.9075 12.6506 36.9075 13.4242C36.9075 14.1978 36.2853 14.825 35.5179 14.825H13.5165C12.7491 14.825 12.127 14.1978 12.127 13.4242Z",
    fill: "#664BF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.127 25.6811C12.127 24.9074 12.7491 24.2803 13.5165 24.2803H22.0855C22.8529 24.2803 23.475 24.9074 23.475 25.6811C23.475 26.4547 22.8529 27.0818 22.0855 27.0818H13.5165C12.7491 27.0818 12.127 26.4547 12.127 25.6811Z",
    fill: "#664BF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0724 44.3C55.0724 37.1762 49.3437 31.4012 42.2769 31.4012C35.2101 31.4012 29.4814 37.1762 29.4814 44.3C29.4814 51.4238 35.2101 57.1988 42.2769 57.1988C49.3437 57.1988 55.0724 51.4238 55.0724 44.3ZM42.2769 28.5996C50.8786 28.5996 57.8516 35.6289 57.8516 44.3C57.8516 52.9711 50.8786 60.0004 42.2769 60.0004C33.6753 60.0004 26.7022 52.9711 26.7022 44.3C26.7022 35.6289 33.6753 28.5996 42.2769 28.5996Z",
    fill: "#664BF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3349 43.4238C43.1023 43.4238 43.7244 44.051 43.7244 44.8246V49.0269C43.7244 49.8006 43.1023 50.4277 42.3349 50.4277C41.5674 50.4277 40.9453 49.8006 40.9453 49.0269V44.8246C40.9453 44.051 41.5674 43.4238 42.3349 43.4238Z",
    fill: "#664BF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3638 40.156C43.1472 40.156 43.7823 39.5289 43.7823 38.7553C43.7823 37.9816 43.1472 37.3545 42.3638 37.3545C41.5804 37.3545 40.9453 37.9816 40.9453 38.7553C40.9453 39.5289 41.5804 40.156 42.3638 40.156Z",
    fill: "#664BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.3fdbd3bc6068c26f7cadd9efd4ebcaa7.svg";
export { ForwardRef as ReactComponent };